const sancionesRoutes = [
  {
    path: '/sanciones', // ya
    name: 'sanciones',
    component: () => import('./views/JefeUnidadView.vue'),
  },
  {
    path: '/sanciones/jefeunidad/:id', // ya
    name: 'sanciones-visualizar',
    component: () => import('./views/JefeUnidadVisualizarView.vue'),
  },
  {
    path: '/sanciones/jefeunidad/expediente/:id', // ya
    name: 'expediente-visualizar',
    component: () => import('./views/JefeUnidadSancionExpediente.vue'),
  },
  {
    path: '/sanciones/solicitud', // ya
    name: 'sanciones-solicitud',
    component: () => import('./views/solicitud.vue'),
  },
  {
    path: '/sanciones/titular', //ya 
    name: 'sanciones-titular',
    component: () => import('./views/TitularView.vue'),
  },
  {
    path: '/sanciones/titular/solicitud/:id',// ya 
    name: 'sanciones-titular-solicitud',
    component: () => import('./views/TitularSolicitud.vue'),
  },
  {
    path: '/sanciones/titular/expediente/:id', // ya
    name: 'sanciones-titular-expediente',
    component: () => import('./views/JefeUnidadSancionExpediente.vue'),
  },
  {
    path: '/sanciones/unidad-juridica', //ya
    name: 'unidad-juridica-view',
    component: () => import('./views/unidadJuridicaTable.vue'),
  },
  // {
  //   path: '/sanciones/unidadjuridica', // no se usa
  //   name: 'unidad-juridica',
  //   component: () => import('./views/unidadJuridica.vue'),
  // },
  {
    path: '/sanciones/resoluciones/:id', // ya
    name: 'resoluciones',
    component: () => import('./views/resoluciones.vue'),
  },
  {
    path: '/sanciones/detallehistorial/:id', //ya
    name: 'detallehistorial',
    component: () => import('./views/resolucionesDetalleHistorial.vue'),
  },
  {
    path: '/sanciones/recursos-humanos', //ya
    name: 'sanciones-rrhh',
    component: () => import('./views/RecursosHumanosView.vue'),
  },
  {
    path: '/sanciones/recursos-humanos/solicitud/:idSolicitud',//ya
    name: 'sanciones-rrhh-solicitud',
    component: () => import('./views/RecursosHumanosSolicitudView.vue'),
  },
  {
    path: '/sanciones/recursos-humanos/historial/detalle/:idSancion',//ya
    name: 'sanciones-rrhh-historial-detalle',
    component: () => import('./views/RecursosHumanosHistorialDetalleView.vue'),
  },
  {
    path: '/sanciones/expediente/:id', // ya
    name: 'sanciones-expediente',
    component: () => import('./views/SancionExpediente.vue'),
  },
];
export default sancionesRoutes;
